import { useMemo, useState } from "react"
import { Box } from "@mui/system"
import { makeStyles } from "tss-react/mui"
import { ez } from "@fullcalendar/core/internal-common"
import { Menu } from "@mui/material"

import { useMenuPlanningItemActions } from "./useMenuPlanningItemActions"

const useStyles = makeStyles()(() => ({
    dayContent: {
        width: "100%",
        padding: ".5rem",
        borderColor: "none",
        backgroundColor: "#eff6ff", //blue[50]
    },
    eventTitle: {
        whiteSpace: "normal",
    },
    event: {
        paddingLeft: "2px !important",
    },
    moreMenu: {
        position: "absolute",
        bottom: ".125rem",
        right: ".125rem",
    },
    meetingTitle: {
        marginTop: ".5rem",
        paddingRight: "1rem",
        color: "#000",
        fontSize: "1rem",
    },
    menu: {
        "& .MuiPaper-root": {
            padding: ".5rem",
            minWidth: "10rem",
            width: "max-content",
        },
    },
}))

export const DayView = ({ event }: { event: ez }) => {
    const { classes, cx } = useStyles()
    const [getActions, dialogs] = useMenuPlanningItemActions()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const onEventClick = (event: React.MouseEvent<HTMLElement>) => {
        if (anchorEl) {
            setAnchorEl(null)
        } else {
            setAnchorEl(event.currentTarget)
        }
    }

    const menuPlanningItem = useMemo(() => {
        return {
            id: +event.id,
            publishDate: event.startStr,
        }
    }, [event])

    return (
        <Box className={cx("fc-event fc-event-start fc-event-end fc-event-past fc-timegrid-event", classes.dayContent)}>
            <Box className={`fc-event-main ${classes.event}`} onClick={onEventClick}>
                <Box className={`fc-event-title-container ${classes.meetingTitle}`}>
                    <Box className={`fc-sticky ${classes.eventTitle}`}>{event.title}</Box>
                </Box>
            </Box>
            {dialogs}
            <Box className={classes.moreMenu}>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    className={classes.menu}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    {getActions(menuPlanningItem)}
                </Menu>
            </Box>
        </Box>
    )
}
